import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import Portfolio from './Portfolio';

const rootElement = document.getElementById('root');
const app = (
  <StrictMode>
    <Portfolio initialLanguage="tr" initialTheme="dark" />
  </StrictMode>
);

if (rootElement.childElementCount > 0) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
